// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"28ac36e3","49":"eaa9f795","64":"367b70c5","96":"c9e47261","273":"3440b18b","624":"f1fdccb2","694":"18cab13e","996":"ef1e9bda"}[chunkId] + ".chunk.css";
};